import type { EvidenceStatus } from "./types";

export const statusLabel: Record<EvidenceStatus, string> = {
  passed: "Passing",
  flaky: "Flaky",
  failed: "Failing",
  skipped: "Skipped",
  fixme: "Known gap",
  missing: "No evidence",
  stale: "Stale evidence",
};

export function evidenceStatus(input: {
  outcome?: string;
  retries?: number;
  expectedStatus?: string;
  runSha?: string;
  exactSha?: string;
}): EvidenceStatus {
  if (input.expectedStatus === "skipped") return "skipped";
  if (input.expectedStatus === "fixme") return "fixme";
  if (!input.outcome) return "missing";
  if (input.runSha && input.exactSha && input.runSha !== input.exactSha) return "stale";
  if (input.outcome === "failed" || input.outcome === "timedOut" || input.outcome === "interrupted") return "failed";
  if ((input.retries ?? 0) > 0) return "flaky";
  return input.outcome === "passed" ? "passed" : "missing";
}
